import { Link } from 'react-router-dom'
import {useRef} from 'react'
import './nav.css'

// Icons
import { GrLinkedinOption } from 'react-icons/gr'
import {AiOutlineMail} from 'react-icons/ai'
import {BsTwitter} from 'react-icons/bs'

import logo from '../../assets/logo.png'

import NavSidebarButton from './NavSidebarButton'

const Nav = ({sidebarIsOpen, setSidebarIsOpen}) =>
{
    // Ref for wrapper
    const wrapperRef = useRef()

    // State for wheel value
    // const [wheel, setWheel] = useState(0)

    // // Event listener for mouse wheel. Hiding and showing nav depending on value
    // useEffect(()=>{
    //     const handleWheel = (e) => {setWheel(e.deltaY) }
    //     window.addEventListener('wheel', handleWheel)

    //     if(wheel >0){
    //         gsap.to(wrapperRef.current, {duration:0.1, y:-100})
    //     } else{
    //         gsap.to(wrapperRef.current, {duration:0.1, y:0})
    //     }

    //     return () =>{
    //         window.removeEventListener('wheel', handleWheel)
    //     }
    // },[wheel])

    return(
        <>
        <nav className="nav" ref={wrapperRef}>
            <Link to="/" className="logo">
                <img src={logo} alt="logo" />
            </Link>

            {/* <div className='nav-socials'>
            <button><GrLinkedinOption /></button>
            <button><AiOutlineMail /></button>
            <button><BsTwitter /></button>
            </div> */}

            <div className="nav-links-wrapper">
                <Link to="/projects" className='nav-links'>Wor<div className='nav-links-character' id='character-K'>K</div></Link>
                <Link to="/about" className='nav-links'>About m<div className='nav-links-character' id='character-E'>E</div></Link>
                <Link to="/contact" className='nav-links'>Let's tal<div className='nav-links-character' id='character-KK'>K</div></Link>
            </div>
        </nav>

        <NavSidebarButton sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />
        </>

    )
}

export default Nav